// const NESTED_RESULTS_URL = `${
//   process.env.PUBLIC_PATH
// }assets/general_contests.json`;
const NESTED_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/general_2018/results.json';
const FLAT_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/general_2018/results_flat.json';
const STATIC_FLAT_RESULTS_URL = `${
  process.env.PUBLIC_PATH
}assets/general-contests-flat-static.json`;
const STATIC_RESULTS_URL = `${
  process.env.PUBLIC_PATH
}assets/general-contests-static.json`;
const HOMEPAGE_URL =
  'https://s3.amazonaws.com/sos.texastribune.org/top-news/2018-general.json';
const STORY_API_URL = (id: number): string =>
  `https://www.texastribune.org/api/v1/content/${id}/?format=json&fields=lead_art,short_summary,url,homepage_headline&__=${+new Date()}`;

export {
  FLAT_RESULTS_URL,
  HOMEPAGE_URL,
  NESTED_RESULTS_URL,
  STATIC_RESULTS_URL,
  STATIC_FLAT_RESULTS_URL,
  STORY_API_URL,
};
